

// import React, { useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Badge, Modal, Button, Form, Alert } from "react-bootstrap";
// import axios from "axios";
// import config from '../../Common/Configurations/APIConfig';
// import DefaultData from '../../Common/CompanyData/DefaultData'; 
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';

// const ServicesList = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [services, setServices] = useState([]);
//     const [filteredServices, setFilteredServices] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
    
//     // Booking modal states
//     const [showBookingModal, setShowBookingModal] = useState(false);
//     const [selectedService, setSelectedService] = useState(null);
//     const [selectedDate, setSelectedDate] = useState(new Date());
//     const [availableSlots, setAvailableSlots] = useState([]);
//     const [selectedTimeSlot, setSelectedTimeSlot] = useState(''); // Stores 24h format (e.g. "14:30")
//     const [bookingNotes, setBookingNotes] = useState('');
//     const [bookingLoading, setBookingLoading] = useState(false);
    
//     // Customer details states
//     const [customerName, setCustomerName] = useState('');
//     const [customerEmail, setCustomerEmail] = useState('');
//     const [customerPhone, setCustomerPhone] = useState('');
    
//     // Authentication states
//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
    
//     // Error messages
//     const [error, setError] = useState('');

//     // Confirmation popup state
//     const [showConfirmation, setShowConfirmation] = useState(false);
//     const [bookingConfirmation, setBookingConfirmation] = useState(null);

//     const THEME_COLOR = '#065f46';
//     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

//     useEffect(() => {
//         checkAuthStatus();
//         const queryParams = new URLSearchParams(location.search);
//         const term = queryParams.get('q') || '';
//         setSearchTerm(term);
//         loadServices(term);
//     }, [location.search]);

//     const checkAuthStatus = () => {
//         const token = localStorage.getItem('token');
//         const user = localStorage.getItem('user');
//         if (token && user) {
//             setIsLoggedIn(true);
//             const parsedUser = JSON.parse(user);
//             setCurrentUser(parsedUser);
//             setCustomerName(parsedUser.name || '');
//             setCustomerEmail(parsedUser.email || '');
//         } else {
//             setIsLoggedIn(false);
//             setCurrentUser(null);
//         }
//     };

//     const loadServices = async (searchTerm) => {
//         try {
//             const servicesRes = await axios.get(config.APIACTIVEURL + config.GETSERVICETYPE);
//             const servicesData = servicesRes.data;
//             let allServices = [];
//             if (servicesData && servicesData.data) {
//                 allServices = servicesData.data || [];
//             }
//             const activeServices = allServices.filter(service => service.isActive);
//             setServices(activeServices);
//             if (searchTerm.trim()) {
//                 const results = activeServices.filter(service =>
//                     service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                     (service.category && service.category.toLowerCase().includes(searchTerm.toLowerCase()))
//                 );
//                 setFilteredServices(results);
//             } else {
//                 setFilteredServices(activeServices);
//             }
//         } catch (error) {
//             console.error("Error fetching services", error);
//             setServices([]);
//             setFilteredServices([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleBookClick = async (service) => {
//         setSelectedService(service);
//         setError('');
//         setShowConfirmation(false);
//         setBookingConfirmation(null);
//         if (!isLoggedIn) {
//             setCustomerName('');
//             setCustomerEmail('');
//             setCustomerPhone('');
//         }
//         await fetchAvailableTimeSlots(service.serviceTypeId, new Date());
//         setShowBookingModal(true);
//     };

//     const fetchAvailableTimeSlots = async (serviceId, date) => {
//         // Using the demo slots generator from your second snippet
//         const slots = generateDemoSlots();
//         setAvailableSlots(slots);
//     };

//     // --- UPDATED FOR 12-HOUR DISPLAY LOGIC ---
//     const generateDemoSlots = () => {
//         const slots = [];
//         for (let hour = 9; hour < 20; hour++) {
//             for (let minute of [0, 30]) {
//                 const h24 = hour.toString().padStart(2, '0');
//                 const m = minute.toString().padStart(2, '0');
//                 const time24 = `${h24}:${m}`; 

//                 const period = hour >= 12 ? 'PM' : 'AM';
//                 const h12 = hour % 12 || 12;
//                 const time12 = `${h12.toString().padStart(2, '0')}:${m} ${period}`;

//                 slots.push({ 
//                     value: time24, 
//                     label: time12, 
//                     available: Math.random() > 0.3 
//                 });
//             }
//         }
//         return slots;
//     };

//     // --- INPUT = OUTPUT TIMING FIX (NAIVE ISO) ---
//     const formatToNaiveISO = (date, timeSlot) => {
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}T${timeSlot}:00`;
//     };

//     const handleDateChange = async (date) => {
//         setSelectedDate(date);
//         if (selectedService) {
//             await fetchAvailableTimeSlots(selectedService.serviceTypeId, date);
//         }
//     };

//     const validateCustomerDetails = () => {
//         if (!isLoggedIn) {
//             if (!customerName.trim()) { setError('Please enter your name'); return false; }
//             if (!customerEmail.trim()) { setError('Please enter your email'); return false; }
//             const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//             if (!emailRegex.test(customerEmail)) { setError('Please enter a valid email address'); return false; }
//         }
//         return true;
//     };

//     const handleBookingSubmit = async (e) => {
//         e.preventDefault();
//         setError('');

//         if (!validateCustomerDetails()) return;
//         if (!selectedTimeSlot) {
//             setError('Please select a time slot');
//             return;
//         }

//         setBookingLoading(true);
//         try {
//             // Updated logic to use Naive ISO strings
//             const startStr = formatToNaiveISO(selectedDate, selectedTimeSlot);
            
//             const [h, m] = selectedTimeSlot.split(':').map(Number);
//             const dateCopy = new Date(selectedDate);
//             dateCopy.setHours(h, m, 0, 0);
//             const endDateObj = new Date(dateCopy.getTime() + (selectedService.durationMinutes || 60) * 60000);
//             const endStr = formatToNaiveISO(endDateObj, `${String(endDateObj.getHours()).padStart(2, '0')}:${String(endDateObj.getMinutes()).padStart(2, '0')}`);

//             const bookingData = {
//                 salonId: selectedService.salonId,
//                 serviceTypeId: selectedService.serviceTypeId,
//                 startTime: startStr,
//                 endTime: endStr,
//                 status: "PENDING",
//                 email: isLoggedIn ? currentUser.email : customerEmail,
//                 customerName: isLoggedIn ? currentUser.name : customerName,
//                 notes: bookingNotes,
//                 ...(customerPhone && { phoneNumber: customerPhone })
//             };

//             const response = await axios.post(
//                 `${config.APIACTIVEURL}${config.CREATEAPPPOINTMENT}`, 
//                 bookingData
//             );
            
//             if (response.data.success) {
//                 const appointmentData = response.data.data;
//                 const displayTime = availableSlots.find(s => s.value === selectedTimeSlot)?.label || selectedTimeSlot;

//                 const bookingDetails = {
//                     appointmentNo: appointmentData?.appointmentNo || 'N/A',
//                     serviceName: selectedService.name,
//                     salonName: appointmentData?.salonName || selectedService.salon?.name,
//                     staffName: appointmentData?.staffName || 'Not assigned',
//                     date: selectedDate.toLocaleDateString(),
//                     time: displayTime, // Show 12hr in confirmation
//                     duration: selectedService.durationMinutes,
//                     price: selectedService.price,
//                     customerName: appointmentData?.customerName || (isLoggedIn ? currentUser.name : customerName),
//                     customerEmail: appointmentData?.customerEmail || (isLoggedIn ? currentUser.email : customerEmail),
//                     status: appointmentData?.status || 'PENDING',
//                     message: response.data.message || 'Appointment booked successfully!'
//                 };
                
//                 setBookingConfirmation(bookingDetails);
//                 setShowConfirmation(true);
//                 resetBookingForm();
//             } else {
//                 setError(response.data.message || 'Failed to create appointment');
//             }
//         } catch (error) {
//             setError(error.response?.data?.message || 'An error occurred. Please try again.');
//         } finally {
//             setBookingLoading(false);
//         }
//     };

//     const resetBookingForm = () => {
//         setSelectedTimeSlot('');
//         setBookingNotes('');
//         setSelectedDate(new Date());
//         setCustomerName('');
//         setCustomerEmail('');
//         setCustomerPhone('');
//         setError('');
//     };

//     const formatPrice = (price) => `${currency} ${price?.toFixed(2) || '0.00'}`;
//     const tileDisabled = ({ date, view }) => view === 'month' && date < new Date().setHours(0,0,0,0);

//     const handleNewSearch = (e) => {
//         e.preventDefault();
//         const newSearchTerm = e.target.search.value.trim();
//         if (newSearchTerm) navigate(`/services/search?q=${encodeURIComponent(newSearchTerm)}`);
//     };

//     return (
//         <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '120px' }}>
//             <div className="container py-4">
//                 {/* Search Bar */}
//                 <div className="row mb-4">
//                     <div className="col-12">
//                         <div className="card border-0 shadow-sm p-3 mb-4" style={{ borderRadius: '1rem' }}>
//                             <form onSubmit={handleNewSearch}>
//                                 <div className="input-group">
//                                     <span className="input-group-text bg-transparent border-0">
//                                         <i className="ri-search-line fs-5" style={{ color: '#065f46' }}></i>
//                                     </span>
//                                     <input
//                                         type="text"
//                                         name="search"
//                                         className="form-control border-0 shadow-none fw-medium py-3"
//                                         placeholder="Search for services..."
//                                         defaultValue={searchTerm}
//                                         autoComplete="off"
//                                     />
//                                     <button type="submit" className="btn text-white px-4" style={{ backgroundColor: THEME_COLOR, borderRadius: '0.75rem' }}>Search</button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Results Header */}
//                 <div className="d-flex justify-content-between align-items-center mb-4">
//                     <div>
//                         <h2 className="h3 fw-bold mb-0 border-bottom border-4 pb-2" style={{ borderColor: '#d1fae5' }}>
//                             {searchTerm ? `Results for "${searchTerm}"` : 'All Services'}
//                         </h2>
//                     </div>
//                     <Badge bg="light" text="dark" className="px-3 py-2">{filteredServices.length} found</Badge>
//                 </div>

//                 {/* Loading State */}
//                 {loading ? (
//                     <div className="text-center py-5"><div className="spinner-border text-primary" role="status"></div></div>
//                 ) : (
//                     <div className="row g-4">
//                         {filteredServices.map(service => (
//                             <div className="col-12 col-md-6 col-lg-4" key={service.serviceTypeId}>
//                                 <div className="card border-0 shadow-sm h-100 p-4" style={{ borderRadius: '1.5rem' }}>
//                                     <h5 className="fw-bold mb-1">{service.name}</h5>
//                                     <p className="text-muted small">{service.category}</p>
//                                     <div className="mb-4">
//                                         <div className="fw-bold text-success mb-1">{formatPrice(service.price)}</div>
//                                         <div className="small text-muted"><i className="ri-time-line"></i> {service.durationMinutes} mins</div>
//                                     </div>
//                                     <button 
//                                         className="btn w-100 py-2 rounded-pill text-white fw-bold"
//                                         style={{ backgroundColor: THEME_COLOR }}
//                                         onClick={() => handleBookClick(service)}
//                                     >
//                                         Book Appointment <i className="ri-calendar-line ms-2"></i>
//                                     </button>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 )}

//                 {/* Booking Modal */}
//                 <Modal show={showBookingModal} onHide={() => { setShowBookingModal(false); setShowConfirmation(false); }} size="lg" centered backdrop="static">
//                     <Modal.Header closeButton className="border-0">
//                         <Modal.Title className="fw-bold" style={{ color: THEME_COLOR }}>
//                             {showConfirmation ? 'Appointment Confirmed!' : 'Book Appointment'}
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         {showConfirmation && bookingConfirmation ? (
//                             <div className="text-center p-3">
//                                 <i className="ri-checkbox-circle-fill" style={{ fontSize: '4rem', color: '#065f46' }}></i>
//                                 <h4 className="fw-bold mt-3">Confirmed!</h4>
//                                 <div className="card bg-light border-0 p-3 my-4 text-start">
//                                     <p><strong>Appointment No:</strong> {bookingConfirmation.appointmentNo}</p>
//                                     <p><strong>Service:</strong> {bookingConfirmation.serviceName}</p>
//                                     <p><strong>Time:</strong> {bookingConfirmation.date} at {bookingConfirmation.time}</p>
//                                 </div>
//                                 <Button variant="danger" className="rounded-pill px-5" onClick={() => setShowBookingModal(false)}>Close</Button>
//                             </div>
//                         ) : (
//                             selectedService && (
//                                 <div className="booking-container">
//                                     {error && <Alert variant="danger">{error}</Alert>}
                                    
//                                     <div className="p-3 mb-4 rounded-3 bg-light border">
//                                         <h5 className="fw-bold mb-1">{selectedService.name}</h5>
//                                         <span className="text-success fw-bold">{formatPrice(selectedService.price)}</span>
//                                     </div>

//                                     <form onSubmit={handleBookingSubmit}>
//                                         <div className="mb-4">
//                                             <h6 className="fw-bold mb-3">Customer Details</h6>
//                                             {isLoggedIn ? (
//                                                 <div className="p-3 rounded border bg-light"><strong>{currentUser?.name}</strong><br/>{currentUser?.email}</div>
//                                             ) : (
//                                                 <div className="row g-3">
//                                                     <div className="col-md-6"><Form.Control placeholder="Name" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></div>
//                                                     <div className="col-md-6"><Form.Control type="email" placeholder="Email" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></div>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         <div className="row">
//                                             <div className="col-lg-6 mb-4">
//                                                 <h6 className="fw-bold mb-3">Select Date</h6>
//                                                 <Calendar onChange={handleDateChange} value={selectedDate} minDate={new Date()} tileDisabled={tileDisabled} className="w-100 border-0" />
//                                             </div>
                                            
//                                             {/* --- UPDATED TIME SLOTS SECTION --- */}
//                                             <div className="col-lg-6 mb-4">
//                                                 <h6 className="fw-bold mb-3">Available Time Slots</h6>
//                                                 <div className="row g-2 overflow-auto" style={{ maxHeight: '250px', paddingRight: '5px' }}>
//                                                     {availableSlots.map((slot, index) => (
//                                                         <div key={index} className="col-4">
//                                                             <button
//                                                                 type="button"
//                                                                 className={`btn btn-sm w-100 ${selectedTimeSlot === slot.value ? 'btn-primary' : slot.available ? 'btn-outline-primary' : 'btn-light'}`}
//                                                                 disabled={!slot.available}
//                                                                 onClick={() => slot.available && setSelectedTimeSlot(slot.value)}
//                                                             >
//                                                                 {slot.label}
//                                                             </button>
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <Form.Control as="textarea" rows={2} className="mb-4" placeholder="Notes (Optional)" value={bookingNotes} onChange={e => setBookingNotes(e.target.value)} />

//                                         <div className="modal-footer border-0 px-0">
//                                             <Button variant="light" onClick={() => setShowBookingModal(false)}>Cancel</Button>
//                                             <Button type="submit" style={{ backgroundColor: THEME_COLOR }} className="text-white px-4" disabled={!selectedTimeSlot || bookingLoading}>
//                                                 {bookingLoading ? 'Processing...' : 'Confirm Appointment'}
//                                             </Button>
//                                         </div>
//                                     </form>
//                                 </div>
//                             )
//                         )}
//                     </Modal.Body>
//                 </Modal>
//             </div>
//         </div>
//     );
// };

// export default ServicesList;

//web view 

import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Badge, Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData'; 
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const ServicesList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [services, setServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    
    // Booking modal states
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(''); 
    const [bookingNotes, setBookingNotes] = useState('');
    const [bookingLoading, setBookingLoading] = useState(false);
    
    const [customerName, setCustomerName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [error, setError] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [bookingConfirmation, setBookingConfirmation] = useState(null);

    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        checkAuthStatus();
        const queryParams = new URLSearchParams(location.search);
        const term = queryParams.get('q') || '';
        setSearchTerm(term);
        loadServices(term);
    }, [location.search]);

    const checkAuthStatus = () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        if (token && user) {
            setIsLoggedIn(true);
            const parsedUser = JSON.parse(user);
            setCurrentUser(parsedUser);
            setCustomerName(parsedUser.name || '');
            setCustomerEmail(parsedUser.email || '');
        } else {
            setIsLoggedIn(false);
            setCurrentUser(null);
        }
    };

    const loadServices = async (searchTerm) => {
        try {
            const servicesRes = await axios.get(config.APIACTIVEURL + config.GETSERVICETYPE);
            const servicesData = servicesRes.data;
            let allServices = [];
            if (servicesData && servicesData.data) { allServices = servicesData.data || []; }
            const activeServices = allServices.filter(service => service.isActive);
            setServices(activeServices);
            if (searchTerm.trim()) {
                const results = activeServices.filter(service =>
                    service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    (service.category && service.category.toLowerCase().includes(searchTerm.toLowerCase()))
                );
                setFilteredServices(results);
            } else { setFilteredServices(activeServices); }
        } catch (error) {
            console.error("Error fetching services", error);
            setServices([]); setFilteredServices([]);
        } finally { setLoading(false); }
    };

    const handleBookClick = async (service) => {
        setSelectedService(service);
        setError('');
        setShowConfirmation(false);
        setBookingConfirmation(null);
        if (!isLoggedIn) { setCustomerName(''); setCustomerEmail(''); setCustomerPhone(''); }
        await fetchAvailableTimeSlots(service.serviceTypeId, new Date());
        setShowBookingModal(true);
    };

    const fetchAvailableTimeSlots = async (serviceId, date) => {
        const slots = generateDemoSlots();
        setAvailableSlots(slots);
    };

    const generateDemoSlots = () => {
        const slots = [];
        for (let hour = 9; hour < 20; hour++) {
            for (let minute of [0, 30]) {
                const h24 = hour.toString().padStart(2, '0');
                const m = minute.toString().padStart(2, '0');
                const time24 = `${h24}:${m}`; 
                const period = hour >= 12 ? 'PM' : 'AM';
                const h12 = hour % 12 || 12;
                const time12 = `${h12.toString().padStart(2, '0')}:${m} ${period}`;
                slots.push({ value: time24, label: time12, available: Math.random() > 0.3 });
            }
        }
        return slots;
    };

    const formatToNaiveISO = (date, timeSlot) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}T${timeSlot}:00`;
    };

    const handleDateChange = async (date) => {
        setSelectedDate(date);
        if (selectedService) { await fetchAvailableTimeSlots(selectedService.serviceTypeId, date); }
    };

    const validateCustomerDetails = () => {
        if (!isLoggedIn) {
            if (!customerName.trim()) { setError('Please enter your name'); return false; }
            if (!customerEmail.trim()) { setError('Please enter your email'); return false; }
        }
        return true;
    };

    const handleBookingSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!validateCustomerDetails()) return;
        if (!selectedTimeSlot) { setError('Please select a time slot'); return; }
        setBookingLoading(true);
        try {
            const startStr = formatToNaiveISO(selectedDate, selectedTimeSlot);
            const [h, m] = selectedTimeSlot.split(':').map(Number);
            const dateCopy = new Date(selectedDate);
            dateCopy.setHours(h, m, 0, 0);
            const endDateObj = new Date(dateCopy.getTime() + (selectedService.durationMinutes || 60) * 60000);
            const endStr = formatToNaiveISO(endDateObj, `${String(endDateObj.getHours()).padStart(2, '0')}:${String(endDateObj.getMinutes()).padStart(2, '0')}`);

            const bookingData = {
                salonId: selectedService.salonId,
                serviceTypeId: selectedService.serviceTypeId,
                startTime: startStr,
                endTime: endStr,
                status: "PENDING",
                email: isLoggedIn ? currentUser.email : customerEmail,
                customerName: isLoggedIn ? currentUser.name : customerName,
                notes: bookingNotes,
                ...(customerPhone && { phoneNumber: customerPhone })
            };

            const response = await axios.post(`${config.APIACTIVEURL}${config.CREATEAPPPOINTMENT}`, bookingData);
            if (response.data.success) {
                const appointmentData = response.data.data;
                const displayTime = availableSlots.find(s => s.value === selectedTimeSlot)?.label || selectedTimeSlot;
                setBookingConfirmation({
                    appointmentNo: appointmentData?.appointmentNo || 'N/A',
                    serviceName: selectedService.name,
                    date: selectedDate.toLocaleDateString(),
                    time: displayTime,
                });
                setShowConfirmation(true);
            } else { setError(response.data.message || 'Failed to create appointment'); }
        } catch (error) { setError(error.response?.data?.message || 'An error occurred.'); } finally { setBookingLoading(false); }
    };

    const formatPrice = (price) => `${currency} ${price?.toFixed(2) || '0.00'}`;
    const tileDisabled = ({ date, view }) => view === 'month' && date < new Date().setHours(0,0,0,0);

    const handleNewSearch = (e) => {
        e.preventDefault();
        const newSearchTerm = e.target.search.value.trim();
        if (newSearchTerm) navigate(`/services/search?q=${encodeURIComponent(newSearchTerm)}`);
    };

    return (
        /* pt-5 mt-5 added to fix Header Overlap on Mobile */
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh' }} className="pt-5 mt-5">
            <div className="container py-lg-4 py-2">
                
                {/* Back Button & Search Bar Fixed for Mobile */}
                <div className="row mb-3 mb-lg-4">
                    <div className="col-12 d-flex align-items-center">
                        <button onClick={() => navigate(-1)} className="btn border-0 p-0 me-2 shadow-none"><i className="ri-arrow-left-line fs-2"></i></button>
                        <div className="card border-0 shadow-sm p-2 flex-grow-1" style={{ borderRadius: '1rem' }}>
                            <form onSubmit={handleNewSearch}>
                                <div className="input-group">
                                    <input type="text" name="search" className="form-control border-0 shadow-none py-2" placeholder="Search services..." defaultValue={searchTerm} />
                                    <button type="submit" className="btn text-white px-3" style={{ backgroundColor: THEME_COLOR, borderRadius: '0.75rem' }}><i className="ri-search-line"></i></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-4 px-1">
                    <h2 className="h5 h-lg-3 fw-bold mb-0 border-bottom border-4 pb-1" style={{ borderColor: '#d1fae5' }}>
                        {searchTerm ? `Results for "${searchTerm}"` : 'All Services'}
                    </h2>
                    <Badge bg="light" text="dark" className="border px-3 py-2">{filteredServices.length} found</Badge>
                </div>

                {loading ? (
                    <div className="text-center py-5"><Spinner animation="border" style={{ color: THEME_COLOR }} /></div>
                ) : (
                    /* col-12 for mobile, col-md-6 for tablet */
                    <div className="row g-3 g-lg-4">
                        {filteredServices.map(service => (
                            <div className="col-12 col-md-6 col-lg-4" key={service.serviceTypeId}>
                                <div className="card border-0 shadow-sm h-100 p-4" style={{ borderRadius: '1.5rem' }}>
                                    <h5 className="fw-bold mb-1">{service.name}</h5>
                                    <p className="text-muted small mb-3">{service.category || 'Professional Service'}</p>
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div>
                                            <div className="fw-bold text-success fs-5">{formatPrice(service.price)}</div>
                                            <div className="small text-muted"><i className="ri-time-line"></i> {service.durationMinutes} mins</div>
                                        </div>
                                    </div>
                                    <button 
                                        className="btn w-100 py-3 rounded-pill text-white fw-bold shadow-sm"
                                        style={{ backgroundColor: THEME_COLOR }}
                                        onClick={() => handleBookClick(service)}
                                    >
                                        Book Now <i className="ri-calendar-line ms-2"></i>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Booking Modal - Optimized for Mobile Thumb usage */}
                <Modal show={showBookingModal} onHide={() => setShowBookingModal(false)} size="lg" centered backdrop="static" fullscreen="md-down">
                    <Modal.Header closeButton className="border-0">
                        <Modal.Title className="fw-bold" style={{ color: THEME_COLOR }}>
                            {showConfirmation ? 'Confirmed!' : 'Book Appointment'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-3 p-lg-4">
                        {showConfirmation && bookingConfirmation ? (
                            <div className="text-center p-3">
                                <i className="ri-checkbox-circle-fill display-3 text-success mb-3"></i>
                                <h4 className="fw-bold">Appointment Booked!</h4>
                                <div className="card bg-light border-0 p-3 my-4 text-start small">
                                    <p className="mb-1"><strong>Appointment No:</strong> {bookingConfirmation.appointmentNo}</p>
                                    <p className="mb-1"><strong>Service:</strong> {bookingConfirmation.serviceName}</p>
                                    <p className="mb-0"><strong>Time:</strong> {bookingConfirmation.date} at {bookingConfirmation.time}</p>
                                </div>
                                <Button onClick={() => setShowBookingModal(false)} className="w-100 rounded-pill py-3 text-white border-0" style={{backgroundColor: THEME_COLOR}}>Back to List</Button>
                            </div>
                        ) : (
                            selectedService && (
                                <div className="text-start">
                                    {error && <Alert variant="danger" className="small">{error}</Alert>}
                                    <div className="p-3 mb-4 rounded-3 bg-light border"><h5 className="fw-bold mb-1 small">{selectedService.name}</h5><span className="text-success fw-bold">{formatPrice(selectedService.price)}</span></div>
                                    <form onSubmit={handleBookingSubmit}>
                                        <div className="mb-4">
                                            <h6 className="fw-bold mb-3 small">Customer Info</h6>
                                            {isLoggedIn ? (
                                                <div className="p-3 rounded border bg-light small"><strong>{currentUser?.name}</strong> ({currentUser?.email})</div>
                                            ) : (
                                                <div className="row g-2">
                                                    <div className="col-12 col-md-6"><Form.Control size="sm" placeholder="Your Name" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></div>
                                                    <div className="col-12 col-md-6"><Form.Control size="sm" type="email" placeholder="Your Email" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="row g-4">
                                            <div className="col-lg-6">
                                                <h6 className="fw-bold mb-3 small">Select Date</h6>
                                                {/* Calendar container to prevent horizontal overflow on mobile */}
                                                <div className="d-flex justify-content-center overflow-auto border rounded p-2 bg-white">
                                                    <Calendar onChange={handleDateChange} value={selectedDate} minDate={new Date()} tileDisabled={tileDisabled} className="w-100 border-0" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <h6 className="fw-bold mb-3 small">Select Time</h6>
                                                <div className="row g-2 overflow-auto" style={{ maxHeight: '200px' }}>
                                                    {availableSlots.map((slot, index) => (
                                                        <div key={index} className="col-4 col-lg-4">
                                                            <button type="button" className={`btn btn-sm w-100 py-2 ${selectedTimeSlot === slot.value ? 'btn-primary' : slot.available ? 'btn-outline-primary' : 'btn-light opacity-50'}`} disabled={!slot.available} onClick={() => setSelectedTimeSlot(slot.value)}>
                                                                {slot.label.replace(' ', '\n')}
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <Form.Control as="textarea" rows={2} className="my-4 small" placeholder="Notes (Optional)" value={bookingNotes} onChange={e => setBookingNotes(e.target.value)} />
                                        <Button type="submit" style={{ backgroundColor: THEME_COLOR }} className="w-100 py-3 text-white fw-bold rounded-pill" disabled={!selectedTimeSlot || bookingLoading}>
                                            {bookingLoading ? 'Booking...' : 'Confirm Appointment'}
                                        </Button>
                                    </form>
                                </div>
                            )
                        )}
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

export default ServicesList;